import { defineMessages } from "react-intl";

export const messages = defineMessages({
    errorHeading: {
        id: "fastshift.dashboard-v2.summary-section-card.error-heading",
        defaultMessage: "An Error Occurred",
        description: "Error heading for the summary section card"
    },
    refreshPage: {
        id: "fastshift.dashboard-v2.summary-section-card.refresh-page-link",
        defaultMessage: "Refresh the page",
        description: "Refresh page link for the summary section card"
    }
});
